import { useEffect } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"

import Style from "./style"

import useAlertModalAtom from "shared/model/useAlertModalAtom"

const PaymentFail = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const orderId = searchParams.get("orderId")
    const errorCode = searchParams.get("code")
    const errorMessage = searchParams.get("message")

    const [, setAlert] = useAlertModalAtom()

    // query 예외처리
    useEffect(() => {
        if (!orderId) {
            setAlert("올바르지 않은 접근입니다.")
            navigate("/")
        }
    }, [])

    return (
        <Style.Wrapper>

            <Style.Header>
                <img src="https://static.toss.im/lotties/error-spot-apng.png" width="120" height="120" />
                <h2 className="title">결제를 실패했어요</h2>
            </Style.Header>

            <Style.ContentDiv>
                <Style.Area>
                    <h2>주문 번호</h2>
                    <p>{orderId}</p>
                </Style.Area>
                <Style.Area>
                    <h2>에러 코드</h2>
                    <p>{errorCode}</p>
                </Style.Area>
                <Style.Area>
                    <h2>에러 메세지</h2>
                    <p>{errorMessage}</p>
                </Style.Area>
            </Style.ContentDiv>

        </Style.Wrapper >
    )
}

export default PaymentFail